const debounce = (func: any, delay: number) => {
  let timeoutId: NodeJS.Timeout;
  // eslint-disable-next-line func-names
  return function (...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      // eslint-disable-next-line prefer-spread
      func.apply(null, args);
    }, delay);
  };
};

export default debounce;
